<template>
	<v-card class="elevation-0" style="width: 550px;">
		<v-card-text :style="'padding-bottom: 0; border: 1px solid ' + (selected ? '#185EA91A' : '#FFFFFF') + '; background-color: ' + (selected ? '#E7EEF6' : '#FFFFFF') + ';'">
			<v-container class="pt-0">
				<v-row>
					<v-col cols="12" class="px-0">
						<span style="font-size: 20px; color: black;" class="d-block">{{ planInfo }}</span>
					</v-col>
					<v-col cols="12" class="pt-0 px-0">
						<span style="height: 80px; font-size: 14px; color: #757575;" class="d-block">{{ description }}</span>
					</v-col>
					<v-col cols="12" class="my-2 px-0" style="border-top: 1px solid #185EA91A; border-bottom: 1px solid #185EA91A; text-align: center;">
						<span style="font-size: 20px; color: black;" class="font-weight-bold">{{ employeePricePerMonth }}</span>						
					</v-col>
					<v-col cols="12" class="my-0 px-0">
						<span style="font-size: 16px; color: black;" class="d-block font-weight-bold">{{ planPlus }}</span>						
						<span style="height: 50px; font-size: 14px;" class="d-block">{{ planPlusDescription }}</span>
					</v-col>
					<v-col cols="12" class="px-0 text-center">
						<v-btn color="#185EA9" text @click="$emit('type-changed', licenseType)" style="font-size: 0.9em; font-weight: 400;">
							{{ $t('wkt.admin.license.upgrade-account-window.step-1.license-info.select_plan') }}
						</v-btn>
					</v-col>
				</v-row>
			</v-container>
		</v-card-text>
	</v-card>
</template>

<script>
import BaseModule from '../../../common/BaseModule.js';
import PurchaseUtils from './PurchaseUtils.js';

export default {
    name: 'LicenseInfo',
    mixins: [BaseModule, PurchaseUtils],
	props: ['licensingInfo','licenseType','licensePlan','selected'],
	components: {
	},
    data () {
		return {
		}
    },
	mounted() {

	},
	computed: {
		planInfo() {
			if (!this.licenseType || !this.licensePlan) {
				return '???';
			}

			let text = '';

			switch (this.licenseType) {
				case this.constants.LICENSE_TYPE_BUSINESS: 
					text = this.$t('wkt.admin.license.type-business-description');
					break;
				case this.constants.LICENSE_TYPE_CORPORATE: 
					text = this.$t('wkt.admin.license.type-corporate-description');
					break;
			}

			text += ' - ';

			switch (this.licensePlan) {
				case this.constants.LICENSE_PLAN_MONTHLY: 
					text += this.$t('wkt.admin.license.plan-monthly-description');
					break;
				case this.constants.LICENSE_PLAN_ANNUAL: 
					text += this.$t('wkt.admin.license.plan-annual-description');
					break;
			}

			return text;
		},
		description() {
			if (!this.licenseType) {
				return '???';
			}

			let text = '';

			switch (this.licenseType) {
				case this.constants.LICENSE_TYPE_BUSINESS: 
					text = this.$t('wkt.admin.license.upgrade-account-window.step-1.license-info.business.description');
					break;
				case this.constants.LICENSE_TYPE_CORPORATE: 
					text = this.$t('wkt.admin.license.upgrade-account-window.step-1.license-info.corporate.description');
					break;
			}

			return text;
		},
		employeePricePerMonth() {
			if (!this.licenseType || !this.licensePlan || !this.licensingInfo) {
				return '???';
			}

			const license = this.findLicenseSKU(this.licensingInfo, this.constants.ACTIVE_EMPLOYEES, this.licenseType, this.licensePlan, this.constants.LICENSE_CLASS_EXTENSION);
			
			if (!license) {
				return '???';
			}

			let description = 'wkt.admin.license-SKU.additional-employee';

			switch (this.licenseType) {
				case this.constants.LICENSE_TYPE_FREE:
					description += '.free';
					break;
				case this.constants.LICENSE_TYPE_BUSINESS:
					description += '.business';
					break;
				case this.constants.LICENSE_TYPE_CORPORATE:
					description += '.corporate';
					break;
			}

			switch (this.licensePlan) {
				case this.constants.LICENSE_PLAN_MONTHLY:
					description += '.monthly';
					break;
				case this.constants.LICENSE_PLAN_ANNUAL:
					description += '.annual';
					break;
			}
			
			return this.$t(description);

			//return license.description;
				
			//return `${license.price.toFixed(2)}€`;
		},
		planPlus() {
			if (!this.licenseType) {
				return '???';
			}

			let text = '';

			switch (this.licenseType) {
				case this.constants.LICENSE_TYPE_BUSINESS: 
					text = this.$t('wkt.admin.license.upgrade-account-window.step-1.license-info.free-plus.title');
					break;
				case this.constants.LICENSE_TYPE_CORPORATE: 
					text = this.$t('wkt.admin.license.upgrade-account-window.step-1.license-info.business-plus.title');
					break;
			}

			return text;
		},
		planPlusDescription() {
			if (!this.licenseType) {
				return '???';
			}

			let text = '';

			switch (this.licenseType) {
				case this.constants.LICENSE_TYPE_BUSINESS: 
					text = this.$t('wkt.admin.license.upgrade-account-window.step-1.license-info.free-plus.description');
					break;
				case this.constants.LICENSE_TYPE_CORPORATE: 
					text = this.$t('wkt.admin.license.upgrade-account-window.step-1.license-info.business-plus.description');
					break;
			}

			return text;
		},
	},
    methods: {		
    },
  }
</script>